(function sccBlogCommerceAnalyticsModule(root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root) return;

  root.SCCBlogCommerceAnalytics = api;
  var boot = function () {
    if (root.document) api.create(root.document);
  };
  if (root.document && root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : null, function createSccBlogCommerceAnalytics() {
  'use strict';

  var EVENT_NAMES = [
    'blog_article_viewed',
    'blog_read_progress',
    'blog_block_viewed',
    'blog_block_clicked',
    'blog_commerce_link_clicked',
    'blog_navigation_clicked',
  ];
  var PARAMETER_NAMES = [
    'store_market',
    'article_handle',
    'blog_type',
    'page_type',
    'locale',
    'block_type',
    'block_slot',
    'destination_type',
    'destination_handle',
    'destination_position',
    'product_source',
    'fallback_collection_handle',
    'read_depth',
    'event_id',
    'exposure_id',
    'occurred_at',
    'schema_version',
  ];
  var DIRECT_STORAGE_KEY = 'scc_blog_commerce_touch_v2';
  var ASSIST_STORAGE_KEY = 'scc_blog_navigation_touch_v2';
  var EXPOSURE_STORAGE_KEY = 'scc_blog_exposure_v1';
  var STORAGE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var QUALIFIED_VIEW_MS = 1000;
  var SENSITIVE_KEY = /(address|coupon|customer|email|name|order|phone|profile|query|token)/i;

  function fallbackUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = Math.floor(Math.random() * 16);
      var value = character === 'x' ? random : (random & 3) | 8;
      return value.toString(16);
    });
  }

  function createPublisher(options) {
    options = options || {};
    var analytics = options.analytics;
    var context = options.context || {};
    var now = options.now || Date.now;
    var randomUUID = options.randomUUID || fallbackUuid;
    var sessionStorage = options.sessionStorage;
    var exposureId = '';

    try { exposureId = sessionStorage && sessionStorage.getItem(EXPOSURE_STORAGE_KEY) || ''; }
    catch (_error) {}
    if (!exposureId) {
      exposureId = randomUUID();
      try { if (sessionStorage) sessionStorage.setItem(EXPOSURE_STORAGE_KEY, exposureId); }
      catch (_error) {}
    }

    function publish(eventName, payload) {
      payload = payload || {};
      if (EVENT_NAMES.indexOf(eventName) === -1) return false;
      if (Object.keys(payload).some(function (key) { return SENSITIVE_KEY.test(key); })) return false;
      if (!analytics || typeof analytics.publish !== 'function') return false;

      var source = {};
      Object.keys(context).forEach(function (key) { source[key] = context[key]; });
      Object.keys(payload).forEach(function (key) { source[key] = payload[key]; });
      var output = {};
      PARAMETER_NAMES.forEach(function (key) {
        if (['event_id', 'exposure_id', 'occurred_at', 'schema_version'].indexOf(key) !== -1) return;
        var value = source[key];
        if (typeof value === 'string') output[key] = value.slice(0, 100);
        else if (typeof value === 'number' && Number.isFinite(value)) output[key] = value;
        else if (typeof value === 'boolean') output[key] = value;
      });
      output.event_id = randomUUID();
      output.exposure_id = exposureId;
      output.occurred_at = new Date(now()).toISOString();
      output.schema_version = 'v1';

      try {
        analytics.publish(eventName, output);
        return true;
      } catch (_error) {
        return false;
      }
    }

    return { publish: publish };
  }

  function create(doc, dependencies) {
    if (!doc) return null;
    dependencies = dependencies || {};
    var win = doc.defaultView || {};
    var layer = doc.querySelector('.scc-blog-layer');
    if (!layer || layer.dataset.sccAnalyticsInitialized === 'true') return null;
    layer.dataset.sccAnalyticsInitialized = 'true';

    var analytics = dependencies.analytics || (win.Shopify && win.Shopify.analytics);
    var Observer = dependencies.IntersectionObserver || win.IntersectionObserver;
    var storage = dependencies.storage || win.localStorage;
    var sessionStorage = dependencies.sessionStorage || win.sessionStorage;
    var fetcher = dependencies.fetch || (win.fetch && win.fetch.bind(win));
    var now = dependencies.now || Date.now;
    var setTimer = dependencies.setTimeout || (win.setTimeout && win.setTimeout.bind(win)) || setTimeout;
    var clearTimer = dependencies.clearTimeout || (win.clearTimeout && win.clearTimeout.bind(win)) || clearTimeout;
    var randomUUID = dependencies.randomUUID
      || (win.crypto && win.crypto.randomUUID && win.crypto.randomUUID.bind(win.crypto))
      || fallbackUuid;
    var blocks = Array.prototype.slice.call(doc.querySelectorAll('[data-scc-commerce-block]'));
    var articleRoot = doc.querySelector('[data-scc-article-body], .scc-article');
    var viewTimers = new Map();
    var viewed = new Set();
    var readMilestones = new Set();
    var context = {
      store_market: layer.dataset.storeMarket || '',
      article_handle: layer.dataset.articleHandle || '',
      blog_type: layer.dataset.blogType || 'informational',
      page_type: layer.dataset.pageType || 'article',
      locale: layer.dataset.locale || doc.documentElement.lang || '',
      fallback_collection_handle: layer.dataset.fallbackCollectionHandle || '',
    };
    var publisher = createPublisher({
      analytics: analytics,
      context: context,
      now: now,
      randomUUID: randomUUID,
      sessionStorage: sessionStorage,
    });

    function payloadFor(block, destination) {
      var payload = {
        block_type: block.dataset.sccBlockType || block.dataset.sccCommerceBlock || '',
        block_slot: block.dataset.sccBlockSlot || '',
        product_source: block.dataset.productSource || '',
        fallback_collection_handle: block.dataset.fallbackCollectionHandle
          || context.fallback_collection_handle,
      };
      if (destination) {
        payload.destination_type = destination.dataset.destinationType || '';
        payload.destination_handle = destination.dataset.destinationHandle || '';
        var destinationPosition = Number(destination.dataset.destinationPosition);
        if (Number.isFinite(destinationPosition)) payload.destination_position = destinationPosition;
      }
      return payload;
    }

    publisher.publish('blog_article_viewed', {});

    function defaultReadProgress() {
      if (!articleRoot || !articleRoot.getBoundingClientRect) return 0;
      var rect = articleRoot.getBoundingClientRect();
      var height = Math.max(articleRoot.scrollHeight || rect.height || 0, 1);
      var viewportHeight = Number(win.innerHeight) || 0;
      return Math.max(0, Math.min(1, (viewportHeight - rect.top) / height));
    }

    var readProgress = dependencies.readProgress || defaultReadProgress;
    function onScroll() {
      var progress = Number(readProgress());
      [25, 50, 75, 90].forEach(function (milestone) {
        if (progress * 100 < milestone || readMilestones.has(milestone)) return;
        readMilestones.add(milestone);
        publisher.publish('blog_read_progress', { read_depth: milestone });
      });
    }
    if (articleRoot && win.addEventListener) win.addEventListener('scroll', onScroll, { passive: true });

    function cancelViewTimer(block) {
      if (!viewTimers.has(block)) return;
      clearTimer(viewTimers.get(block));
      viewTimers.delete(block);
    }

    var observer = Observer ? new Observer(function (entries) {
      entries.forEach(function (entry) {
        var block = entry.target;
        if (viewed.has(block)) return;
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
          cancelViewTimer(block);
          return;
        }
        if (viewTimers.has(block)) return;
        var timer = setTimer(function () {
          viewTimers.delete(block);
          if (viewed.has(block)) return;
          viewed.add(block);
          publisher.publish('blog_block_viewed', payloadFor(block));
          if (observer && typeof observer.unobserve === 'function') observer.unobserve(block);
        }, QUALIFIED_VIEW_MS);
        viewTimers.set(block, timer);
      });
    }, { threshold: [0, 0.5, 1] }) : null;
    if (observer) blocks.forEach(function (block) { observer.observe(block); });

    function readTouch(storageKey) {
      if (!storage) return null;
      try {
        var value = JSON.parse(storage.getItem(storageKey) || 'null');
        if (!value || !Number.isFinite(value.touchedAt) || now() - value.touchedAt > STORAGE_TTL_MS) {
          storage.removeItem(storageKey);
          return null;
        }
        return value;
      } catch (_error) {
        return null;
      }
    }

    function writeTouch(storageKey, first, last) {
      if (!storage) return;
      try { storage.setItem(storageKey, JSON.stringify({ first: first, last: last, touchedAt: now() })); }
      catch (_error) {}
    }

    function touchToken(value, fallback, maximum) {
      var token = String(value || fallback || '');
      if (!token || token.length > maximum || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(token)) return '';
      if (/^\d[\d-]{6,}$/.test(token)) return '';
      return token;
    }

    function touchArticle(value, maximum) {
      var identity = String(value || '');
      if (!identity || identity.length > maximum) return '';
      var segments = identity.split('/');
      if (segments.length < 1 || segments.length > 2) return '';
      return segments.every(function (segment) {
        return Boolean(segment) && touchToken(segment, '', maximum) === segment;
      }) ? identity : '';
    }

    function touchSlot(value) {
      if (value === 'body' || value === 'header' || value === 'end') return value;
      if (typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) return '';
      return Number(value) <= 500 ? value : '';
    }

    function touchValue(payload, prefix) {
      var namespace = prefix === 'blog_assist' ? 'blog_assist' : prefix === 'blog' ? 'blog' : '';
      var blogTypes = ['how-to', 'informational', 'product-adjacent', 'best-of', 'furniture-intent'];
      var blockTypes = ['collection-link', 'collection-portal', 'collection-product', 'collection-products',
        'featured-product', 'navigation', 'organic-link'];
      var destinationTypes = ['blog', 'cart', 'collection', 'home', 'other', 'page', 'product', 'search'];
      var productSources = ['editorial', 'fallback-collection', 'featured-product', 'navigation'];
      var values = [
        namespace,
        touchArticle(context.article_handle, 100),
        blogTypes.indexOf(context.blog_type) === -1 ? '' : context.blog_type,
        blockTypes.indexOf(payload.block_type) === -1 ? '' : payload.block_type,
        touchSlot(payload.block_slot),
        destinationTypes.indexOf(payload.destination_type) === -1 ? '' : payload.destination_type,
        touchToken(payload.destination_handle, '', 100),
        productSources.indexOf(payload.product_source) === -1 ? '' : payload.product_source,
        touchToken(payload.fallback_collection_handle, 'unknown', 100),
      ];
      if (values.some(function (value) { return !value; })) return '';
      var touch = values.join('|');
      return touch.length <= 200 ? touch : '';
    }

    function carryToCart(attributes) {
      if (!fetcher) return;
      Promise.resolve(fetcher('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: attributes }),
      })).catch(function () {});
    }

    function recordTouch(storageKey, prefix, attributePrefix, payload) {
      var last = touchValue(payload, prefix);
      if (!last) return false;
      var current = readTouch(storageKey);
      var first = current ? current.first : last;
      writeTouch(storageKey, first, last);
      var attributes = {};
      attributes[attributePrefix + '_first_touch'] = first;
      attributes[attributePrefix + '_last_touch'] = last;
      carryToCart(attributes);
      return true;
    }

    function destinationFor(url) {
      var commerce = url.pathname.match(/^\/(products|collections)\/([a-z0-9][a-z0-9-]*)\/?$/i);
      if (commerce) return {
        type: commerce[1] === 'products' ? 'product' : 'collection',
        handle: commerce[2],
      };
      if (/^\/$/.test(url.pathname)) return { type: 'home', handle: 'home' };
      if (/^\/search\/?$/i.test(url.pathname)) return { type: 'search', handle: 'search' };
      if (/^\/cart\/?$/i.test(url.pathname)) return { type: 'cart', handle: 'cart' };
      var page = url.pathname.match(/^\/(pages|blogs)\/([a-z0-9][a-z0-9-]*)/i);
      if (page) return { type: page[1] === 'pages' ? 'page' : 'blog', handle: page[2] };
      return { type: 'other', handle: 'other' };
    }

    function linkUrl(anchor) {
      try { return new URL(anchor.getAttribute('href') || anchor.href, win.location && win.location.href); }
      catch (_error) { return null; }
    }

    function decorateLink(anchor, payload) {
      var url = linkUrl(anchor);
      if (!url || !win.location || url.origin !== win.location.origin) return;
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (/^utm_/i.test(key)) url.searchParams.delete(key);
      });
      url.searchParams.set('scc_article', context.article_handle || 'unknown');
      url.searchParams.set('scc_type', context.blog_type || 'informational');
      url.searchParams.set('scc_block', payload.block_type || 'unknown');
      anchor.setAttribute('href', url.pathname + url.search + url.hash);
    }

    function onClick(event) {
      var target = event.target;
      var destination = target && target.closest && target.closest('[data-scc-destination]');
      var block = destination && destination.closest('[data-scc-commerce-block]');
      var anchor;
      var payload;
      if (block && doc.documentElement.contains(block)) {
        payload = payloadFor(block, destination);
        anchor = target.closest('a[href]');
        if (anchor) decorateLink(anchor, payload);
        publisher.publish('blog_block_clicked', payload);
        recordTouch(DIRECT_STORAGE_KEY, 'blog', 'scc', payload);
        return;
      }

      anchor = target && target.closest && target.closest('a[href]');
      if (!anchor) return;
      var url = linkUrl(anchor);
      if (!url || !win.location || url.origin !== win.location.origin) return;
      var resolved = destinationFor(url);
      if (articleRoot && articleRoot.contains(anchor)) {
        if (['product', 'collection'].indexOf(resolved.type) === -1) return;
        payload = {
          block_type: 'organic-link',
          block_slot: 'body',
          destination_type: resolved.type,
          destination_handle: resolved.handle,
          destination_position: 1,
          product_source: 'editorial',
          fallback_collection_handle: context.fallback_collection_handle,
        };
        decorateLink(anchor, payload);
        publisher.publish('blog_commerce_link_clicked', payload);
        recordTouch(DIRECT_STORAGE_KEY, 'blog', 'scc', payload);
        return;
      }
      if (!anchor.closest('header')) return;
      payload = {
        block_type: 'navigation',
        block_slot: 'header',
        destination_type: resolved.type,
        destination_handle: resolved.handle,
        destination_position: 1,
        product_source: 'navigation',
        fallback_collection_handle: context.fallback_collection_handle,
      };
      decorateLink(anchor, payload);
      publisher.publish('blog_navigation_clicked', payload);
      recordTouch(ASSIST_STORAGE_KEY, 'blog_assist', 'scc_blog_assist', payload);
    }

    doc.addEventListener('click', onClick);
    return { publisher: publisher };
  }

  return {
    EVENT_NAMES: EVENT_NAMES.slice(),
    PARAMETER_NAMES: PARAMETER_NAMES.slice(),
    create: create,
    createPublisher: createPublisher,
  };
});
